export const INVOKE_CAPABILITY = 'INVOKE_CAPABILITY';

// NOTE: Messasges in this file are intended for use with `iframeable`

export const isInvokeCapabilityMsg = msg => msg.payload.type === INVOKE_CAPABILITY && 'name' in msg.payload && 'source' in msg.payload;